/*
エラーコード作成方針
E+6桁（数字）で構成する。
- 1~2桁目の値は種類（業務エラー、システムエラー...）
- 3~4桁目の値は原因箇所（Cognito、Sentinel、DB、SessionDB...）
- 5~6桁目の値は任意の重複しない値
ex)
E00XXXX : システムエラー（通信エラーやDB接続失敗など）
E01XXXX : 業務エラー（Fingerprintが不正など）
EXX00XX : 内部エラー（内部プログラムのエラー）
EXX01XX : Sentinelエラー（Sentinel関連）
EXX02XX : Cognitoエラー（Cognito関連）
EXX03XX : DBエラー（DB関連）
EXX04XX : SessionDBエラー（SessionDB関連）
EXX05XX : reCAPTCHAエラー（reCAPTCHA関連）
EXX06XX : SESエラー（SESメール送信関連）
*/
export const errorCodes = [
  "E000201", // Cognito認証エラー
  "E000202", // Cognito認証コード不正エラー
  "E000203", // パスワード変更時のCognitoエラー
  "E000204", // パスワードリセット時のCognitoエラー
  "E000205", // Cognito試行回数制限超過エラー
  "E010101", // SentinelでFingerPrint不正エラー
  "E010102", // SentinelでEmail不正エラー
  "E010103", // SentinelでRevocationTicket不正エラー
  "E000104", // パスワードリセット時のSentinelエラー
  "E000105", // パスワード変更時のSentinelエラー
  "E000501", // reCAPTCHA通信エラー
  "E010501", // reCAPTCHAの検査で不合格
  "E000601", // SESメール送信失敗エラー
  "E009999", // 汎用エラー
] as const;
